import(/* webpackMode: "eager" */ "/vercel/path0/apps/ahnu/src/app/[lang]/(main)/error.tsx");
